// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__6_K2D","imageUploader":"EGiftCard_imageUploader__21cnq"};